import { render, staticRenderFns } from "./headPage.vue?vue&type=template&id=97014ee2&scoped=true"
import script from "./headPage.vue?vue&type=script&lang=js"
export * from "./headPage.vue?vue&type=script&lang=js"
import style0 from "./headPage.vue?vue&type=style&index=0&id=97014ee2&prod&lang=scss&scoped=true"
import style1 from "./headPage.vue?vue&type=style&index=1&id=97014ee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97014ee2",
  null
  
)

export default component.exports